import { render, staticRenderFns } from "./MailgunTemplates.vue?vue&type=template&id=7b480e36&"
import script from "./MailgunTemplates.vue?vue&type=script&lang=js&"
export * from "./MailgunTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports